import '@config/instrument';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
// eslint-disable-next-line import/no-unresolved
import { ToastContainer, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { masks } from 'dateformat';

import '@assets/scss/bootstrap.scss';
import 'bootstrap/dist/js/bootstrap';

import '@app/index.css';

import reportWebVitals from '@app/reportWebVitals';
import routes from '@app/routes';
import store from '@app/store';
import { ScrollButton } from '@components/Buttons/ScrollButton';
import DefaultSpinner from '@components/Loader/Loader';
import { PAYPAL_CLIENT_ID } from '@config/const';
import { availableDateFormats } from '@config/dateFormats';
import { Page503 } from '@containers/ErrorPages';
import { CheckRemoteVersion } from '@features/CheckRemoteVersion';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { authApi } from '@reducers/auth';
import { skipToken } from '@reduxjs/toolkit/query';

const App = () => {
  const { token } = useSelector((state) => state.auth);
  const { isAvailable } = useSelector((state) => state.system);
  Object.entries(availableDateFormats).forEach(([attribute, value]) => {
    masks[attribute] = value;
  });
  authApi.useGetUserQuery(token ? {} : skipToken);
  if (!isAvailable) {
    return <Page503 />;
  }
  return (
    <PayPalScriptProvider options={{ 'client-id': PAYPAL_CLIENT_ID }}>
      <Router>
        <Suspense fallback={<DefaultSpinner />}>{routes}</Suspense>
      </Router>
    </PayPalScriptProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Flip}
      />
      <ScrollButton />
      <CheckRemoteVersion />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
